/**
 * Checks a string for a length limit and appends an ellipses
 * if the string length is over
 * @param  {String} str   [the string to be checked]
 * @param  {Int} limit [the max length of the string]
 * @return {String}
 */
export default function(str, limit) {
  if (str && str.length > limit) {
    return `${str.substring(0, limit)}...`;
  }
  return str;
}



// WEBPACK FOOTER //
// ./src/client/utils/ellipse.js